// @flow
const localStorageWrapper = (key: string) => ({
  set: (businessHash: string) => localStorage.setItem(key, businessHash),
  get: (): Object => {
    const json = localStorage.getItem(key);
    let parsedJson: Object = {};

    if (json) {
      try {
        parsedJson = JSON.parse(json);
      } catch (_) {
        localStorage.removeItem(key);
      }
    }

    return parsedJson;
  },
  clear: () => {
    localStorage.removeItem(key);
  },
});

export default localStorageWrapper;



// WEBPACK FOOTER //
// ./src/utils/local-storage-wrapper.js